/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';
import Helmet from 'react-helmet';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import favicon from './img/favicon.ico';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Central do Assinante Cabonnet';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="cabonet-body">
      <Helmet>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <div className="row h-100">
        <div className="col-sm-12">
          <Row>
            <Col sm="4"></Col>
            <Col sm="4">
              {
                _validateParams()
                  ? <LoginForm
                    api={api}
                    location={location}
                  />
                  : <RequestLoginErrorMessage
                    onlyMessage={true}
                    message={translate('RequestLoginErrorMessage')}
                  />
              }
            </Col>
            <Col sm="4"></Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}

export default Login;
